import { jsx as _jsx } from "react/jsx-runtime";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
export const LoadingPage = () => {
    return (_jsx(LoadingSpinner, { containerStyles: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } }));
};
